<script lang="ts">import { isMobile } from "@infinitro/global";
import { Text } from "@infinitro/text";
import VipBenefitsCard from "./vip-benefits-card.svelte";
import VipRewardCard from "./vip-reward-card.svelte";
export let title;
export let description;
export let rewards = [];
export let descriptionMaxWidth = "90%";
</script>

{#key $isMobile}
	<VipBenefitsCard>
		<div class="vip-benefit-section-content">
			<Text
				type={'subtitle'}
				subtitleSize={$isMobile ? 'small' : 'large'}
				subtitleWeight="semibold"
				textAlign="center">{title}</Text
			>

			<Text
				type="body"
				bodySize={$isMobile ? 'small' : 'large'}
				textAlign="center"
				customStyle={`max-width: ${descriptionMaxWidth}`}
			>
				{description}
			</Text>
		</div>

		<div class="vip-benefit-rewards">
			{#each rewards as reward (reward.title)}
				<VipRewardCard title={reward.title} image={reward.image} />
			{/each}
		</div>
	</VipBenefitsCard>
{/key}

<style>
	.vip-benefit-rewards {

		display: flex;

		width: 100%;

		flex-wrap: wrap;

		align-items: center;

		justify-content: center;

		gap: 0.5rem
}

	.vip-benefit-section-content {

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: center;

		justify-content: center;

		gap: 0.5rem
}

	@media (min-width: 1024px) {
		.vip-benefit-rewards {

				flex-wrap: nowrap;

				gap: 1rem
		}
	}
</style>
